
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmPlaceholder } from "@afe/amui/src/components/Placeholder";
import Login from "./Login.vue";
import Restore from "./Restore.vue";
import RestoreByPhone from "./RestoreByPhone.vue";
import RestoreByPhoneConfirmation from "./RestorePasswordConfirmRequest.vue";
import Confirm from "./Confirm.vue";
import Verify from "./Verify.vue";
import OneTimePassword from "./OneTimePassword.vue";
import { api } from "../api";
import {
  LOGIN_STEPS,
  getLoginFlow,
  getLoginOptions,
  AUTH_METHODS,
  redirectDashboard
} from "../service";

@Component({
  components: {
    Login,
    Restore,
    Confirm,
    Verify,
    OneTimePassword,
    RestoreByPhone,
    RestoreByPhoneConfirmation,
    AmPlaceholder
  }
})
export default class extends Vue {
  @Prop(String) readonly json!: string;
  configLogin = JSON.parse(this.json);
  configRestore = {};
  configConfirm = {};
  configVerify = {};
  isLoading = false;

  formData: any = {
    formClass: `sign-up form-${this.configLogin.form_label}`
  };

  STEPS = LOGIN_STEPS;
  currentStep = LOGIN_STEPS.LOGIN_STEP;

  loginOptions = getLoginOptions({
    phone: this.configLogin.fields.phone_number.label,
    email: this.configLogin.fields.email.label
  });

  currentFlow = getLoginFlow(AUTH_METHODS.EMAIL);
  authMethod = AUTH_METHODS.EMAIL;

  mounted() {
    api.setLocale(this.configLogin.locale);
  }

  onLoginStep() {
    this.currentStep = this.STEPS.LOGIN_STEP;
  }

  onFlowChange(flow: string) {
    this.authMethod = flow;
    this.currentFlow = getLoginFlow(flow);
  }

  onRedirect(data: any) {
    if (data && data.login_url) {
      redirectDashboard(data.login_url, data.misc.is_new_dashboard ?? false);
    }
  }

  onCodeConfirm(data: any) {
    this.formData = { ...this.formData, ...data };
    this.currentStep = this.STEPS.RESTORE_BY_PHONE_CONFIRMATION_STEP;
  }
  async onOtpStep(formData: object) {
    this.formData = { ...this.formData, ...formData };
    this.currentStep = this.STEPS.ONE_TIME_PASSWORD_STEP;
  }

  async onRestoreStep(email: string) {
    if (this.authMethod === AUTH_METHODS.EMAIL) {
      this.formData = { ...this.formData, email };
      const { data } = await api.forms.resetPasswordForm();
      this.configRestore = data;
      this.currentStep = this.STEPS.RESTORE_STEP;
    } else {
      this.currentStep = this.STEPS.RESTORE_BY_PHONE_STEP;
    }
  }

  async onVerifyStep(formData: object) {
    this.formData = { ...this.formData, ...formData };
    const { data } = await api.forms.verifyEmail();
    this.configVerify = data;
    this.currentStep = this.STEPS.VERIFY_STEP;
  }

  async onConfirmSubmit() {
    const { data } = await api.forms.passwordRestoreConfirmation();
    this.configConfirm = data;
    this.currentStep = this.STEPS.CONFIRM_STEP;
  }

  onRestoreByEmail() {
    this.authMethod = AUTH_METHODS.EMAIL;
    this.onRestoreStep("");
  }
}
